<div *ngIf="!fileName" class="drag-and-drop-file" appDragAndDropFile (filesDrop)="filesDrop($event)">
  <i class="fa fa-upload drag-and-drop-file__upload-icon" aria-hidden="true"></i>

  <span>
    Drag & drop file to upload or
    <span class="drag-and-drop-file__link" (click)="fileInputClick(fileInput)">browse</span>
    <input type="file" class="drag-and-drop-file__file-input" (change)="selectedFileChange($event)" #fileInput />
  </span>
</div>

<div
  *ngIf="fileName"
  appDragAndDropFile
  class="drag-and-drop-file drag-and-drop-file--populated"
  [ngClass]="{
    'drag-and-drop-file--invalid': invalidFiles
  }"
  (filesDrop)="filesDrop($event)"
>
  <span class="drag-and-drop-file__name" [attr.title]="fileName">
    {{ fileName }}
  </span>

  <i class="fa fa-times-circle drag-and-drop-file__clear-icon" aria-hidden="true" title="Clear" (click)="clearInput()">
  </i>
</div>
